export const GET_ACTIVE_DB = "GET_ACTIVE_DB";
export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const SET_ACTIVE_STORE = "SET_ACTIVE_STORE";
export const GET_DELIVERY_COUNT = "GET_DELIVERY_COUNT";
